/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Parameter { 
    /**
     * Name of the parameter
     */
    name: string;
    /**
     * Value of the parameter. If the name of the parameter contains the word \"password,\" this value will be masked before being                   logged into the                   application logs                
     */
    value?: string;
}
